import React from 'react';
import Container from '../shared/Container';
import { Button, Spinner } from 'flowbite-react';
import { LiaLongArrowAltLeftSolid, LiaLongArrowAltRightSolid } from 'react-icons/lia';
import { HiOutlineStar, HiStar } from 'react-icons/hi';

interface Props {
	isLoading?: boolean;
	isConnecting: boolean;
	hasUserConnected: boolean;
	handleConnect: () => void;
	disableConnect: boolean;
	placedElseWhere: boolean;
	disableLeftChevron: boolean;
	disableRightChevron: boolean;
	onClickLeftChevron: () => void;
	onClickRightChevron: () => void;
}

const ConnectWithCandidateComponent = ({
	isLoading,
	isConnecting,
	hasUserConnected,
	handleConnect,
	disableConnect,
	placedElseWhere,
	disableLeftChevron,
	disableRightChevron,
	onClickLeftChevron,
	onClickRightChevron,
}: Props) => {
	return (
		<Container className="fixed bottom-0 left-0 right-0 flex w-full !p-0 md:!px-[0px] xl:!px-[80px] z-[3]">
			<div className="w-[430px] sm:w-0 h-0 bg-[green]"></div>
			<div className="flex flex-row-reverse justify-between p-4 bg-white dark:bg-[#18222D] grow-2 mt-[-70px] !shadow-[0px_-8px_32px_0px_rgba(0,_0,_0,_0.10)] dark:shadow-none">
				{placedElseWhere ? (
					<>
						<div className="w-fit bg-[#FCE8F3] px-[10px] py-[4px] rounded-[6px] flex items-center">
							<p className=" text-[#99154B] font-inter text-[14px] font-[500] leading-[18px]">Placed Elsewhere</p>
						</div>
					</>
				) : (
					<>
						{isConnecting || isLoading ? (
							<Spinner />
						) : hasUserConnected ? (
							<div className="flex gap-1 justify-center items-center">
								<Button
									color="purplePlaced"
									disabled={disableConnect}
									className="[&_span]:!p-0 !px-[16px] !py-[8px] border-[#E5E7EB]"
								>
									<HiStar className="h-[16px] w-[16px] mr-[8px] text-[#FDDD48]" />
									Shortlisted
								</Button>
							</div>
						) : (
							<Button
								color="purplePlaced"
								disabled={disableConnect}
								className="[&_span]:!p-0 !px-[16px] !py-[8px] border-[#E5E7EB]"
								onClick={handleConnect}
							>
								<HiOutlineStar className="mr-[8px]" />
								Shortlist
							</Button>
						)}
					</>
				)}
				<div className="flex gap-2">
					<Button
						color="light"
						className="text-[#1C1C28] rounded-[8px] p-[8px] [&>span]:!p-0"
						disabled={disableLeftChevron}
						onClick={onClickLeftChevron}
					>
						<LiaLongArrowAltLeftSolid className="w-[24px] h-[24px]" />
					</Button>

					<Button
						color="light"
						className="text-[#1C1C28] rounded-[8px] p-[8px] [&>span]:!p-0"
						disabled={disableRightChevron}
						onClick={onClickRightChevron}
					>
						<LiaLongArrowAltRightSolid className="w-[24px] h-[24px]" />
					</Button>
				</div>
			</div>
		</Container>
	);
};

export default ConnectWithCandidateComponent;
